import React, {Component} from 'react'
import {Button} from 'reactstrap'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import axios from 'axios'
import NumberFormat from 'react-number-format'
import { APIURL } from '../../config/config'
import pdfMake from 'pdfmake/build/pdfmake'

const SLASH_DMYHMS = 'DD MMM YYYY HH:mm:ss'

class HistoryStockOut extends Component {
  constructor (props){
    super(props)
    this.state = {
      date_start: new Date(),
      date_end: new Date(),
      stockOut: []
    }

    this.handleDateStart = this.handleDateStart.bind(this)
    this.handleDateEnd   = this.handleDateEnd.bind(this)
    this.loadHistoryStockOut   = this.loadHistoryStockOut.bind(this)
  }

  componentDidMount() {

    //if(this.props.viewType==='daily') {
      this.loadHistoryStockOut();
    //}

  }
  //
  componentWillReceiveProps(nextProps){
    if(nextProps.reloadSummaryStockOut !== this.props.reloadSummaryStockOut){
      if(nextProps.reloadSummaryStockOut){
        this.loadHistoryStockOut();
      }
    }
  }


  handleDateStart(date){
    this.setState({
      date_start: date
    })
  }

  handleDateEnd(date){
    this.setState({
      date_end: date
    })
  }

  loadHistoryStockOut() {

    if(this.state.date_start > this.state.date_end){
      alert('วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ')
      return
    }

    let date_start =  moment(this.state.date_start).format('YYYY-MM-DD')
    let date_end   =  moment(this.state.date_end).format('YYYY-MM-DD')
    let url = APIURL+'/stock_out/history/'+date_start+'/'+date_end

    axios.get(url).then(res => {
      // console.log(res.data)
      if(res.status === 200){
        this.setState({
          stockOut: res.data
        },()=>{
          if(this.props.reloadSummaryStockOut){
            this.props.onReloadSummaryStockOutFinish();
          }
        });
      }
    })

  }

  printHistoryStockOut(stockOut, date_start, date_end) {
    console.log('print stockOut history | ', stockOut)
    var dateHeader = ''
    if(date_start === date_end){
      dateHeader = moment(this.state.date_start).locale('th').format('LL')
    }else{
      dateHeader = moment(date_start).locale('th').format('LL') + ' ถึง '+ moment(date_end).locale('th').format('LL')
    }

    var headerDoc = 'ประวัติการเบิกอะไหล่วันที่ '+dateHeader

    var tableStockOut = [];
    var tableHeader = [
        { text: '#',                 style: 'textBold' },
        { text: 'วันที่',               style: 'textBold' },
        { text: 'ชื่ออะไหล่รถ [ราคา]',  style: 'textBold' },
        { text: 'จำนวนเบิก',          style: 'textBold' },
        { text: 'เบิกใช้กับ',           style: 'textBold' },
        { text: 'ผู้เบิก',              style: 'textBold' },
    ]

    tableStockOut.push(tableHeader)

    for (let i = 0; i < stockOut.length; i++) {
      let sparePart = stockOut[i]
      let index = i + 1
      let date = moment(sparePart.stock_out_created).locale('th').format(SLASH_DMYHMS)
      let namePrice = sparePart.name+ '['+sparePart.price.toLocaleString()+' บ.]'
      let qtyUnit = sparePart.quantity + ' '+ sparePart.unit
      let useFor = sparePart.use_for+': '+sparePart.car_name+' '+sparePart.car_license
      let requestor = sparePart.requestor

      var tableRow = [
        { text: index,      style: 'textNormal' },
        { text: date,       style: 'textNormal' },
        { text: namePrice,  style: 'textNormal' },
        { text: qtyUnit,    style: 'textNormalCenter' },
        { text: useFor,     style: 'textNormal' },
        { text: requestor,  style: 'textNormal' },
      ]
      tableStockOut.push(tableRow)
    }

    //portrait  landscape
    var docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [ 56, 30, 56, 30 ],
      content: [
        { text: headerDoc, style: 'textHeader', lineHeight:1.3},
        {
          table: {
            headerRows: 1,
            body: tableStockOut
          }
        }
      ],
      styles: {
        textHeader: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        textNormal: {
          fontSize: 14
        },
        textNormalCenter: {
          fontSize: 14,
          alignment: 'center'
        },
        textBold: {
          fontSize: 14,
          bold: true,
          alignment: 'center'
        },
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    }

    pdfMake.createPdf(docDefinition).open()

  }

  render() {


    let stockOutList = this.state.stockOut.map((sparePart, index) => {

      //if(sparePart.quantity_out === 0) return null

      return (
        <tr key={index+1}>
          <td>{index+1}</td>
          <td>{moment(sparePart.stock_out_created).locale('th').format(SLASH_DMYHMS)}</td>
          <td>
            {sparePart.name}
            &nbsp;
            [
            <NumberFormat
              displayType={'text'}
              thousandSeparator={true}
              value={sparePart.price}/>
            &nbsp;บ.
            ]
            </td>
          <td className="text-center">{sparePart.quantity} &nbsp; {sparePart.unit} </td>
          <td>
            {sparePart.use_for} : &nbsp;
            {sparePart.car_name} &nbsp; {sparePart.car_license}
          </td>
          <td>{sparePart.requestor}</td>
        </tr>
      )

    })

    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="card card-accent-success">
            <div className="card-header">
              <strong>ประวัติการเบิกอะไหล่</strong>
            </div>
            <div className="card-block">
              <div className={this.props.viewType==='daily' ? 'row  mb-2' : 'hidden'}>
                <div className="col-12">
                  <h4> ประวัติการเบิกอะไหล่วันที่ {moment().locale('th').format('LL')} </h4>
                </div>
              </div>
              <div className={this.props.viewType==='range' ? 'row  mb-2' : 'hidden'}>
                  <div className="col-1 text-right pt-1">
                     วันที่เริ่ม
                  </div>
                  <div className="col-2">
                    <DatePicker
                      selected={this.state.date_start}
                      onChange={this.handleDateStart}
                      dateFormat="yyyy-MM-dd"
                      type="text"
                      className="form-control"
                      placeholder=""
                    />
                  </div>

                  <div className="col-2 text-right pt-1">
                    <span className="" > วันที่สิ้นสุด </span>
                  </div>
                  <div className="col-2">
                      <DatePicker
                        selected={this.state.date_end}
                        onChange={this.handleDateEnd}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-control"
                        placeholder=""
                      />
                  </div>
                <div className="col-1">
                  <Button color="success" size="sm" onClick={()=>this.loadHistoryStockOut()}>
                    <i className="icon-magnifier"></i>&nbsp; ตกลง
                  </Button>
                </div>
                <div className={this.state.stockOut.length===0? "hidden" : "col-1"} >

                  <Button color="info" size="sm"
                          onClick={()=>{
                            let stockOut = this.state.stockOut;
                            let date_start = this.state.date_start;
                            let date_end = this.state.date_end;
                            this.printHistoryStockOut(stockOut,date_start,date_end);
                          }}>
                    <i className="icon-docs"></i>&nbsp; พิมพ์
                  </Button>

                  {/*<button type="button"
                          className="btn btn-sm btn-info btn-block"
                          onClick={() => {
                            // console.log(car_sell)
                            //this.printInvoice(car_sell);
                          }}
                  >
                    <i className="icon-docs"></i>&nbsp; พิมพ์
                  </button>*/}

                </div>
              </div>

              <div className={this.props.viewType==='range' ? 'row  mb-2' : 'hidden'}>
                <div className={moment(this.state.date_start).isSame(moment(this.state.date_end), 'date')? "hidden": 'col-12' }>
                  <h4> ประวัติการเบิกอะไหล่วันที่ {moment(this.state.date_start).locale('th').format('LL')}  ถึง {moment(this.state.date_end).locale('th').format('LL')}</h4>
                </div>
                <div className={moment(this.state.date_start).isSame(moment(this.state.date_end), 'date')? "col-12": 'hidden' }>
                  <h4> ประวัติการเบิกอะไหล่วันที่ {moment(this.state.date_start).locale('th').format('LL')} </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <table className="table table-striped">
                    <thead>
                    <tr>
                      <td>#</td>
                      <td>วันที่</td>
                      <td>ชื่ออะไหล่รถ [ราคา]</td>
                      <td className="text-center">จำนวนเบิก</td>
                      <td>เบิกใช้กับ</td>
                      <td>ผู้เบิก</td>
                    </tr>
                    </thead>
                    <tbody>
                    {stockOutList}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HistoryStockOut;